import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  updateEntityListDataMultiple,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getSupplierProductItemListData,
  getSupplierProductItemsDataForSupplierProduct,
} from './mockData'
import type { ISupplierProductItem } from '~/types/supplierProductItem/models'

export type GetSupplierProductItemsResponse = {
  data: ISupplierProductItem[]
}

async function getSupplierProductItems(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetSupplierProductItemsResponse = {
    data: await getSupplierProductItemListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

async function getSupplierProductItemsForSupplierProduct(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(`'Returning supplierProduct items for supplierProduct "${id}".`)
  const responseBody = {
    data: await getSupplierProductItemsDataForSupplierProduct(id),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postSupplierProductItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getSupplierProductItemListData)
}

const patchSupplierProductItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getSupplierProductItemListData)
}

const patchSupplierProductItems = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListDataMultiple(
    req,
    res,
    ctx,
    getSupplierProductItemListData
  )
}

const deleteSupplierProductItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getSupplierProductItemListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/supplierProductitems/:id',
    handler: getSupplierProductItemsForSupplierProduct,
  },
  {
    method: 'post',
    path: '/api/supplierProductitems',
    handler: postSupplierProductItem,
  },
  {
    method: 'patch',
    path: '/api/supplierProductitems/:id',
    handler: patchSupplierProductItem,
  },
  {
    method: 'patch',
    path: '/api/supplierProductitems',
    handler: patchSupplierProductItems,
  },
  {
    method: 'delete',
    path: '/api/supplierProductitems/:id',
    handler: deleteSupplierProductItem,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
